import {Task} from "@megaphonenpm/mputils/src/Task.js";
import {
  CHANGE,
  COMPLETE
} from '@megaphonenpm/mputils/src/constants.js';
import {notNil, union} from '@megaphonenpm/mputils/src/utils.js';
import {log} from '@megaphonenpm/mputils/src/logfunctions.js';
import {MegaScreen} from "./MegaScreen.js";
import {CLIENT_TYPE_SCREEN} from '@megaphonenpm/mrtsclient/src/constants.js';

export class LoadMediaTask extends Task {
  constructor () {
    super();
    this.name = 'LOAD_MEDIA';
    this.boundMediaCacheChangeListener = this.mediaCacheChangeListener.bind(this);
    this.boundMediaCacheCompleteListener = this.mediaCacheCompleteListener.bind(this);
  }

  registerMediaCacheListeners () {
    MegaScreen.globals.mediaCache.on(CHANGE, this.boundMediaCacheChangeListener);
    MegaScreen.globals.mediaCache.on(COMPLETE, this.boundMediaCacheCompleteListener);
  }

  unregisterMediaCacheListeners () {
    MegaScreen.globals.mediaCache.off(CHANGE, this.boundMediaCacheChangeListener);
    MegaScreen.globals.mediaCache.off(COMPLETE, this.boundMediaCacheCompleteListener);
  }

  start () {
    super.start();

    let playlistScreenMediaURIs = MegaScreen.globals.playlistService.getPlaylistMediaURIs(
      MegaScreen.globals.dataStore.playlist,
      CLIENT_TYPE_SCREEN);
    let webpollScreenMediaURIs = MegaScreen.globals.playlistService.getPlaylistMediaURIs(
      Object.fromEntries(MegaScreen.globals.dataStore.webpolls),
      CLIENT_TYPE_SCREEN);
    let deploymentSettingsScreenMediaURIs =
      MegaScreen.globals.deploymentSettingsService.getDeploymentSettingsMediaURIs(
        MegaScreen.globals.dataStore.deploymentSettings,
        CLIENT_TYPE_SCREEN);
    const themeBaseURI = MegaScreen.globals.themeLoader.getThemeBaseURI();
    let socialiconURIs = new Set();
    socialiconURIs.add(`${themeBaseURI}global/socialicon-twitter.png`);
    socialiconURIs.add(`${themeBaseURI}global/socialicon-facebook.png`);
    socialiconURIs.add(`${themeBaseURI}global/socialicon-instagram.png`);
    socialiconURIs.add(`${themeBaseURI}global/socialicon-whatsapp.png`);
    socialiconURIs.add(`${themeBaseURI}global/socialicon-twitch.png`);
    socialiconURIs.add(`${themeBaseURI}global/socialicon-ugc.png`);

    let socialbgURIs = new Set();
    socialbgURIs.add(`${themeBaseURI}global/socialbg-twitter.png`);

    let allMediaURIs = union(deploymentSettingsScreenMediaURIs, playlistScreenMediaURIs, webpollScreenMediaURIs, socialiconURIs, socialbgURIs);

    this.registerMediaCacheListeners();
    log(`Loading ${allMediaURIs.size} media assets...`);
    MegaScreen.globals.mediaCache.load(allMediaURIs);
  }

  mediaCacheChangeListener (e) {
    // If the asset that just triggered CHANGE is found in the cache, then it
    // loaded successfully; otherwise, it failed to load.
    if (notNil(MegaScreen.globals.mediaCache.get(e.detail.uri))) {
      log(`Media asset loaded (${MegaScreen.globals.mediaCache.pendingURIs.size} remaining):\n` + e.detail.uri);
    } else {
      log(`Media asset load failed (${MegaScreen.globals.mediaCache.pendingURIs.size} remaining):\n` + e.detail.uri);
    }

    // Report task progress
    let cache = MegaScreen.globals.mediaCache;
    let numAssetsResolved = cache.numFailed + cache.numSucceeded;
    this.setProgress(numAssetsResolved/cache.numAssets);
  }

  mediaCacheCompleteListener (e) {
    log('All playlist media loaded.');
    this.unregisterMediaCacheListeners();
    this.done();
  }
}
